export const FETCH_PROCESS_DEFN_REQUEST = "FETCH_PROCESS_DEFN_REQUEST";
export const FETCH_PROCESS_DEFN_SUCCESS = "FETCH_PROCESS_DEFN_SUCCESS";
export const FETCH_PROCESS_DEFN_FAILURE = "FETCH_PROCESS_DEFN_FAILURE";
